<nav class="">
    <div class="flex flex-wrap items-center justify-between mx-auto py-4 gap-6">
        <a routerLink="/" class="flex items-center space-x-3 rtl:space-x-reverse">
            <img src="images/wecodeit_logo.svg" class="h-8" alt="WeCodeIt OG Logo" />
        </a>
        <button
            data-collapse-toggle="navbar-default"
            type="button"
            class="inline-flex items-center p-2 w-10 h-10 justify-center text-sm text-gray-500 rounded-lg !hidden hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-200"
            aria-controls="navbar-default"
            aria-expanded="false">
            <span class="sr-only">Open main menu</span>
            <svg
                class="w-5 h-5"
                aria-hidden="true"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 17 14">
                <path
                    stroke="currentColor"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M1 1h15M1 7h15M1 13h15" />
            </svg>
        </button>
        <div class="hidden w-full lg:block lg:w-auto" id="navbar-default">
            <ul
                class="font-medium flex flex-col p-4 lg:p-0 mt-4 border items-center border-gray-100 rounded-lg bg-dark lg:flex-row lg:space-x-8 rtl:space-x-reverse lg:mt-0 lg:border-0 lg:pl-6 lg:pr-2 lg:py-2 lg:rounded-full">
                <li>
                    <a
                        routerLink="/"
                        class="text-sm xl:text-base font-light no-underline block py-2 px-2 text-white rounded-sm hover:bg-gray-100 lg:hover:bg-transparent lg:border-0 lg:hover:text-secondary-600 lg:p-0"
                        >Start</a
                    >
                </li>
                <li>
                    <a
                        routerLink="/"
                        fragment="projects"
                        class="text-sm xl:text-base font-light no-underline block py-2 px-2 text-white rounded-sm hover:bg-gray-100 lg:hover:bg-transparent lg:border-0 lg:hover:text-secondary-600 lg:p-0"
                        >Projekte</a
                    >
                </li>
                <li>
                    <a
                        routerLink="/"
                        fragment="services"
                        class="text-sm xl:text-base font-light no-underline block py-2 px-2 text-white rounded-sm hover:bg-gray-100 lg:hover:bg-transparent lg:border-0 lg:hover:text-secondary-600 lg:p-0"
                        >Leistungen</a
                    >
                </li>
                <li>
                    <a
                        routerLink="/"
                        fragment="about"
                        class="text-sm xl:text-base font-light no-underline block py-2 px-2 text-white rounded-sm hover:bg-gray-100 lg:hover:bg-transparent lg:border-0 lg:hover:text-secondary-600 lg:p-0"
                        >Über uns</a
                    >
                </li>
                <li>
                    <a
                        routerLink="/"
                        fragment="how"
                        class="text-sm xl:text-base font-light no-underline block py-2 px-2 text-white rounded-sm hover:bg-gray-100 lg:hover:bg-transparent lg:border-0 lg:hover:text-secondary-600 lg:p-0"
                        >Wie funktioniert's?</a
                    >
                </li>
                <li>
                    <a
                        routerLink="/"
                        fragment="faq"
                        class="text-sm xl:text-base font-light no-underline block py-2 px-2 text-white rounded-sm hover:bg-gray-100 lg:hover:bg-transparent lg:border-0 lg:hover:text-secondary-600 lg:p-0"
                        >FAQ</a
                    >
                </li>
                <li>
                    <wci-button
                        routerLink="/kontakt"
                        label="Kontakt"
                        buttonClass="!px-4 !py-2 [&>svg]:!h-5 !text-sm xl:!text-base "
                        >Kontakt</wci-button
                    >
                </li>
            </ul>
        </div>
    </div>
</nav>
